// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.
export function loadDashboardUrlState(search) {
    const state = {
        view: 'table',
        filter: 'all'
    };
    try {
        const params = new URLSearchParams(search);
        const viewParam = params.get('view');
        const filterParam = params.get('filter');
        if (viewParam === 'graph' || viewParam === 'table') {
            state.view = viewParam;
        }
        if (filterParam === 'failed-warn' || filterParam === 'all') {
            state.filter = filterParam;
        }
    }
    catch (_a) {
        // ignore invalid URL state
    }
    return state;
}
export function syncDashboardUrlState(view, filter) {
    try {
        const params = new URLSearchParams(window.location.search);
        params.set('view', view);
        params.set('filter', filter);
        const newUrl = window.location.pathname + '?' + params.toString() + window.location.hash;
        window.history.replaceState(null, '', newUrl);
    }
    catch (_a) {
        // ignore browser APIs unavailable
    }
}
//# sourceMappingURL=urlState.js.map